@if (data$ | async; as component) {
  <div class="vertical-selection-container" [style]="'background-color :'+ component.background">
    @if (component.title) {
      @switch (component.titleTag) {
        @case ('H1') {
          <h1
            class="h2-component title"
            [style.color]="component.titleColor"
            [style.font-size]="component.titleSize"
            [style.font-weight]="component.titleBold === 'true' ? 'bold' : '400'"
            >
            {{component.title}}
          </h1>
        }
        @case ('H2') {
          <h2
            class="h2-component title"
            [style.color]="component.titleColor"
            [style.font-size]="component.titleSize"
            [style.font-weight]="component.titleBold === 'true' ? 'bold' : '400'"
            >
            {{component.title}}
          </h2>
        }
        @default {
          <div
            class="h2-component title"
            [style.color]="component.titleColor"
            [style.font-size]="component.titleSize"
            [style.font-weight]="component.titleBold === 'true' ? 'bold' : '400'"
            >
            {{component.title}}
          </div>
        }
      }
    }
    @if ((isMobile() | async)) {
      <cx-carousel
        [items]="items$ | async"
        [template]="carouselItem"
        itemWidth="75%"
        [hideIndicators]="true"
        [hideButtons]="false"
        [animation]="animation"
        >
      </cx-carousel>
    } @else {
      <cx-carousel
        [items]="items$ | async"
        [template]="carouselItem"
        itemWidth="25%"
        [hideIndicators]="true"
        [hideButtons]="false"
        [animation]="animation"
        >
      </cx-carousel>
    }
  </div>
}

<ng-template #carouselItem let-item="item">
  <app-custom-item-vertical-four [item]="item"></app-custom-item-vertical-four>
</ng-template>
